module.exports = __webpack_public_path__ + "static/media/reward-pool-info.e84e3217.png";